import { __awaiter } from 'tslib';
import { fetchGet } from './fetch.js';

const castPromiseToUndefined = (promise) => promise.then(() => undefined);
const castPromiseToItself = (promise, url, fetcher) => __awaiter(void 0, void 0, void 0, function* () {
    return yield promise.then(() => fetcher ? fetcher(url) : fetchGet(url));
});

export { castPromiseToItself, castPromiseToUndefined };
